import clsx from 'clsx';
import kebabCase from 'lodash/kebabCase';

import { Content } from '@/lib';
import styles from './TableOfContents.module.scss';
import { Row } from '../../Row';

interface TableOfContentsProps extends Content.WithFluid<Content.TableOfContents> {
  headers: Content.DataItem<Content.Type.header, Content.Header>[];
}

export function TableOfContents({ headers, fluid }: TableOfContentsProps) {
  if (!headers.length) return null;
  return (
    <Row className={clsx(fluid && styles.fluid)}>
      <div className={styles.wrapper}>
        <h2 className={clsx('h2', styles.title)}>Table of Contents</h2>
        <ul className={styles.list}>
          {headers.map((block, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={index} className={clsx('text', styles.item, block.data.level === 3 && styles.levelThree)}>
              <a href={`#${kebabCase(block.data.text)}`}>{block.data.text}</a>
            </li>
          ))}
        </ul>
      </div>
    </Row>
  );
}
